import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import type { PlacementWithoutOpening } from '@recruitee/placements-types';

@Injectable({
  providedIn: 'root',
})
export class PlacementsWithoutOpeningsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetch$(
    jobId: number,
  ): Observable<{ placements: PlacementWithoutOpening[]; jobId: number }> {
    return this.httpApi.get(`/offers/${jobId}/placements/without_openings`).pipe(
      map(response => ({
        placements: response.placements,
        jobId,
      })),
    );
  }
}
